<template>
    <v-app pb-3>
        <v-content>
            <v-form>
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap>
                        <v-flex xs12 md10>
                            <h1>Личный кабинет</h1>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container style="max-width: 1200px;">
                    <v-layout wrap row>
                        <v-flex
                            class="service-item" xs12 sm6
                            v-for="(service, key) in services"
                            :key="key"
                            v-show="service.show"
                        >
                            <span v-if="service.count" class="kbm-badge">{{service.count}}</span>
                            <img
                                class="kbm-image"
                                v-if="service.img"
                                :src="service.img"
                            />
                            <a
                                @click="service.isNewPolis ? toDisplay = true : openLink(service.link)"
                               :class="[{ newPolis: service.isNewPolis }, 'service-link']"
                               v-html="service.name"/>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
        <b2b-policy-type-dialog
            :links="policyTypesArray"
            :hideButton="true"
            :toDisplay="toDisplay"
            @changeDialog="changeDialog"
            :showBankingProducts="showBankingProducts"
        ></b2b-policy-type-dialog>
    </v-app>
</template>

<script>
import PolicyTypeDialogButton from "../elements/PolicyTypeDialogButton.vue";

export default {
    components: {
        'b2b-policy-type-dialog': PolicyTypeDialogButton
    },
    props: [
        'policyTypes',
        'user',
    ],
    data: () => ({
        services: [],
        toDisplay: false,
        policyTypesArray: [],
        showBankingProducts: false
    }),
    created() {

        this.services = [
            {
                name: 'Страховые продукты',
                link: '/list',
                img: '/svg/list.svg',
                show: true,
            },
            {
                name: 'Новый полис',
                link: '',
                img: '/svg/plus_2.svg',
                isNewPolis: true,
                show: true,
            },
            {
                name: 'Все сотрудники',
                link: '/agents',
                show: true,
            },
            {
                name: 'Баланс',
                link: '/accounting-list',
                show: this.user && this.user.type !== 'physical',
            },
            {
                name: 'Вознаграждение',
                link: '/commissions',
                img: '/svg/persent.svg',
                show: true,
            },
            {
                name: 'Сервисы',
                link: '/b2b-services',
                show: true,
            },
            {
                name: 'Профиль',
                link: '/profile',
                img: 'https://static.tildacdn.com/tild3863-6264-4161-b031-393634366239/man.svg',
                show: true,
            },
            {
                name: 'Частые вопросы',
                link: '/agent-faq',
                img: 'https://static.tildacdn.com/tild6466-3661-4230-b765-323165613937/question.svg',
                show: true,
            },
            {
                name: 'Руководство по сайту',
                link: '/guide/produktovaya-lineyka',
                show: true,
            },
        ];
        this.policyTypesArray = JSON.parse(window.atob(this.policyTypes));

        if (this.user && !this.user.is_transit_open) {
            this.policyTypesArray = this.policyTypesArray.filter(item => item.name !== 'ОСАГО не РФ');
        }
    },
    methods: {
        openLink(url) {
            window.open(url, '_self');
        },
        changeDialog(value) {
            this.toDisplay = value
        },
    }
}
</script>

<style scoped>

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFUIDisplay', Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}
.service-item {
    width: 100%;
    position: relative;
}

.service-link {
    display: block;
    background-color: #f1f2f3;
    border-radius: 12px;
    width: 100%;
    height: 100%;
    color: black;
    text-decoration: none;
    font-family: 'SFUIDisplay', Arial, sans-serif;
    font-size: 26px;
    padding: 20px;
}

.newPolis {
    color: #ffffff;
    background-color: #00ba57 !important;
    line-height: 1.55;
    border-radius: 10px;
    background-position: center center;
    border-style: solid;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}

.kbm-badge {
    font-family: 'SFPro';
    font-weight: 700;
    font-size: 14px;
    color: #fff !important;
    background: #00ba57;
    border-radius: 50%;
    max-width: 32px;
    max-height: 32px;
    min-width: 32px;
    min-height: 32px;
    width: 32px;
    height: 32px;
    padding: 6px;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
    position: absolute;
    right: 20px;
    cursor: pointer;
}

.kbm-image {
    position: absolute;
    width: 48px;
    height: 48px;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
    position: absolute;
    right: 30px;
    cursor: pointer;
}


@media (min-width: 600px) {
    .service-item {
        height: 250px;
    }

    .kbm-badge {
        top: 32px;
    }

    .kbm-image {
        top: 180px;
    }
}

.service-item:hover {
    -webkit-filter: brightness(95%);
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
    transition: all 0.5s ease;
}

@media (max-width: 959px) {
    h1 {
        font-size: 50px;
    }
}

@media (max-width: 639px) {
    .service-link {
        font-size: 18px;
    }

}

@media (max-width: 599px) {
    .kbm-badge {
        top: 24px;
    }

    .kbm-image {
        width: 24px;
        height: 24px;
        top: 28px;
    }

    .kbm-image:nth-child(2) {
        display: none;
    }

    .service-link {
        padding: 16px 20px;
    }

    h1 {
        font-size: 30px;
    }
}

@media (max-width: 479px) {
}

</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/DashboardAgent.vue